var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Page",
    { attrs: { title: _vm.title } },
    [
      _c("div", { staticClass: "header-titile-all" }, [
        _c("div", { staticClass: "searchTitle-top-header flex" }, [
          _c("div", { staticClass: "searchTitle-top" }, [
            _c(
              "div",
              { staticClass: "picker-alls", on: { click: _vm.chooseScope } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.queryFlagText) + "\n          "
                ),
                _c("div", { staticClass: "triangle_border_down" })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex input-search-flex" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.queryParam.customerName,
                    expression: "queryParam.customerName"
                  }
                ],
                ref: "inputText",
                staticClass: "search_input",
                attrs: { type: "text", placeholder: "客户姓名" },
                domProps: { value: _vm.queryParam.customerName },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.submitInput(_vm.queryParam)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.queryParam,
                      "customerName",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filtrate-list flex",
              on: {
                click: function($event) {
                  return _vm.searchInput(_vm.queryParam)
                }
              }
            },
            [
              _c("img", {
                staticClass: "filtrate-img",
                attrs: { src: require("@/assets/img/search.png"), alt: "" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flexJ" }, [
          _c("div", { staticClass: "filtrate-lists-areaList" }, [
            _c(
              "div",
              {
                staticClass: "date-selector",
                on: {
                  click: function($event) {
                    return _vm.selectTime(1)
                  }
                }
              },
              [
                _vm.queryParam.dateFrom
                  ? _c("span", [
                      _vm._v(_vm._s(_vm._f("getDate")(_vm.queryParam.dateFrom)))
                    ])
                  : _c("span", [_vm._v("创建日期")]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "uparrow",
                  attrs: {
                    src: require("@/assets/img/uparrow.png"),
                    alt: "",
                    srcset: ""
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex column-center" }, [
              _c("span", [_vm._v("至")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "date-selector",
                on: {
                  click: function($event) {
                    return _vm.selectTime(1.1)
                  }
                }
              },
              [
                _vm.queryParam.dateTo
                  ? _c("span", [
                      _vm._v(_vm._s(_vm._f("getDate")(_vm.queryParam.dateTo)))
                    ])
                  : _c("span", [_vm._v("创建日期")]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "uparrow",
                  attrs: {
                    src: require("@/assets/img/uparrow.png"),
                    alt: "",
                    srcset: ""
                  }
                })
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "scrollView", staticClass: "scroll-view" },
        [
          _c(
            "van-list",
            {
              ref: "page",
              attrs: {
                finished: _vm.finished,
                "immediate-check": false,
                "finished-text": "没有更多了"
              },
              on: { load: _vm.onLoad },
              model: {
                value: _vm.loading,
                callback: function($$v) {
                  _vm.loading = $$v
                },
                expression: "loading"
              }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "scroll-view-list-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "information-list",
                      on: {
                        click: function($event) {
                          return _vm.viewCustomerTraffic(item.trafficId)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "information-list-item item-lists flex justify-content-space-between"
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              { staticClass: "boldFonts item-label" },
                              [_vm._v("到店时间段:")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "activeFonts" }, [
                              _vm._v(
                                _vm._s(_vm._f("getTime")(item.dateFrom)) +
                                  " -\n                " +
                                  _vm._s(_vm._f("getTime")(item.dateTo))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "boldFonts" }, [
                            item.status === "0"
                              ? _c("span", [_vm._v("草稿")])
                              : _vm._e(),
                            _vm._v(" "),
                            item.status === "1"
                              ? _c("span", [_vm._v("已提交")])
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "information-list-item item-lists" },
                        [
                          _c("span", { staticClass: "boldFonts item-label" }, [
                            _vm._v("客户姓名:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "activeFonts" }, [
                            _vm._v(
                              _vm._s(item.customerName ? item.customerName : "")
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "information-list-item item-lists" },
                        [
                          _c("span", { staticClass: "boldFonts item-label" }, [
                            _vm._v("客户类型:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "activeFonts" }, [
                            _vm._v(
                              _vm._s(item.customerType ? item.customerType : "")
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "information-list-item item-lists" },
                        [
                          _c("span", { staticClass: "boldFonts item-label" }, [
                            _vm._v("是否试机:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "activeFonts" }, [
                            _vm._v(_vm._s(item.test ? "是" : "否"))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "information-list-item item-lists" },
                        [
                          _c("span", { staticClass: "boldFonts item-label" }, [
                            _vm._v("创建日期:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "activeFonts" }, [
                            _vm._v(_vm._s(item.createdTime || ""))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.hasTrafficCreated
            ? "orientation-bottom"
            : "orientation-bottom-single"
        },
        [
          _c("div", { staticClass: "homePage", on: { click: _vm.home } }, [
            _c("img", {
              staticClass: "homePageImg",
              attrs: { src: require("@/assets/img/homePage.png"), alt: "" }
            })
          ]),
          _vm._v(" "),
          _vm.hasTrafficCreated
            ? _c(
                "div",
                { staticClass: "add", on: { click: _vm.addCustomerTraffic } },
                [
                  _c("img", {
                    staticClass: "addImg",
                    attrs: { src: require("@/assets/img/add.png"), alt: "" }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.columns,
              "value-key": "name"
            },
            on: { cancel: _vm.onCancel, confirm: _vm.onConfirm }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { width: "100%" },
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.timeShow,
            callback: function($$v) {
              _vm.timeShow = $$v
            },
            expression: "timeShow"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: { type: "date" },
            on: {
              confirm: _vm.timeConfirm,
              cancel: _vm.timeCancel,
              change: _vm.timeChange
            },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "loaded",
          style: { bottom: this.$store.state.show == 2 ? "1.2rem" : "0rem" }
        },
        [
          _vm._v(
            "\n    已加载 " +
              _vm._s(this.list.length) +
              "/" +
              _vm._s(_vm.totalRow) +
              "\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21cb3aea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21cb3aea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/customerTraffic.vue
// module id = null
// module chunks = 